import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';
import styled from 'styled-components';

export const ActualNews = styled.div`
    width: 100%;
    padding: 30px 20px 50px;

    @media screen and (max-width: 768px) {
        padding: 30px 0 50px;
    }
`;

export const ActualNewsTitle = styled.h2`
    margin: 10px 0;
    ${FONTS.H3};
`;

export const ActualSliderWrap = styled.div`
    margin: 0 -10px;
    width: 100%;

    @media screen and (max-width: 768px) {
        margin: 0;
    }
`;

export const ActualCardWrap = styled.div`
    padding: 0 10px;
    width: 100%;

    @media screen and (max-width: 768px) {
        padding: 0;
    }
`;
